/* eslint-disable */
import 'jcarousel';
import 'jquery.cookie';

import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';
import '@fr/pages/desktop/travelata/travelata/atlas/css/atlas-header-withMenu.scss';
import '@fr/pages/desktop/travelata/travelata/atlas/css/atlas-page-sections.css';
import './destination-info-restinrussia.css'

import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import SocialButtons from "@/js/desktop/components/social-btns";
import DestinationViewRussia from './View/Destination'
import SearchFormAutocompleteView from '@/js/desktop/components/searchFormAutocomplete/SearchFormAutocomplete'
import fromRouterHydrator from "./Hydrator/fromRouterRussia";
import toRouterHydrator from "./Hydrator/toRouterRussia";

var Controller = AbstractSearchController.extend({
	fromRouterHydrator: fromRouterHydrator,
	toRouterHydrator: toRouterHydrator,
	initSearchForm: function () {
		this.searchFormView = new SearchFormAutocompleteView({
			DestinationView: DestinationViewRussia
		});
	},
	initGallery:function() {
		function initCarousel(selector) {
			const paginationSelector = `${selector}-pagination`;
			
			$(selector)
				.on('jcarousel:create jcarousel:reload', function() {
					var element = $(this),
						width = element.innerWidth();
					element.jcarousel('items').css('width', width + 'px');
				})
				.jcarousel();

			$(paginationSelector).jcarouselPagination({
				item: function(page, $image) {
					return '<span style="background-image:url(' + $image.data('preview') + ')"> </span>';
				}
			});

			$(paginationSelector)
				.on('jcarouselpagination:active', 'span', function() {
					$(this).addClass('active');
				})
				.on('jcarouselpagination:inactive', 'span', function() {
					$(this).removeClass('active');
				});

			if (!$(paginationSelector + " span.active").length) {
				$(paginationSelector + " span:first-child").addClass("active");
			}
		}

		initCarousel('.imageGallery');
		initCarousel('.jcarouselImg');
	},
	initSocialButtons() {
		new SocialButtons({
			el: '.social-btns'
		});
	},
	initialize() {
		$.removeCookie('requestFromMainPage', {path: '/', domain: 'all'});
		tourCriteriaService.clearTourCriteriaChangedFields();

		AbstractSearchController.prototype.initialize.call(this);
		this.initGallery();
		this.initSocialButtons()
	}
});

$(() => {
	const searchController = new Controller({
		el: 'body'
	});

	searchController.initSearchOnScroll();
});
